type Item = {
  id: number;
  title: string;
  key: string;
  alt?: string;
};

type Props = {
  title?: string;
  items: Item[];
};

export const EquipmentCollapseContent = ({ title, items }: Props) => (
  <>
    {title && <p className="py-2 body-14-semibold">{title}</p>}
    <ul className="m-0 list-disc px-5">
      {items.map((item) => (
        <li
          key={item.id}
          title={item.alt}
          className="body-14-light before:hidden after:hidden"
        >
          {item.title}
        </li>
      ))}
    </ul>
  </>
);
